

















import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { stringToBig } from '@/helper'
import { AVAX_ID } from '@/known_assets'

@Component({})
export default class AddressResult extends Vue {
    @Prop() item!: any | null

    select() {
        // TODO: support for multiple chains. add a chain param
        const url = `/address/X-${this.item.address}`
        this.$router.push(url)
        this.$emit('select')
    }

    get avaxBalance() {
        return stringToBig(
            this.item.assets[AVAX_ID].balance,
            this.avaxDenomination
        )
    }

    get avaxDenomination() {
        return this.$store.state.assets[AVAX_ID].denomination
    }

    get avaxSymbol() {
        return this.$store.state.assets[AVAX_ID].symbol
    }

    get numTx() {
        return this.item.transactionCount
    }

    get chainNow() {
        return this.$store.state.chainId
    }

    get prefixedAddress() {
        return `${this.chainNow}-${this.item.address}`
    }
}
